import React, { useEffect } from 'react';
import { Paper, Box } from '@mui/material';
import { Downgraded, useState } from '@hookstate/core';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import UserListDialog from '../../sharedcomponents/userList/userListDialog';
import EditParticipant from './editParticipant';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import { useAuthState } from '../../stores/authStore';
import DataList from '../../sharedcomponents/dataList/dataList';
import ConnectionListDialog from '../../sharedcomponents/connection/ConnectionListDialog';
import DeleteConnectionDialog from '../../sharedcomponents/confirmationdialog/deleteConnectionDialog';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import SyncParticipant from './syncParticipants';
import EditAllParticipant from './editAllParticipant';
import TicketSettingsDialog from '../../sharedcomponents/userList/ticketSettingsDialog';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: '16px',
        },
    },
}));

const Allotment = (props) => {
    const classes = useStyles();
    const setAll = useState(false);
    const users = useState([]);
    const allParticipants = useState([]);
    const openDialog = useState(false);
    const openUserDialog = useState(false);
    const openUserEditAllDialog = useState(false);
    const openSyncParticipants = useState(false);
    const syncParticipantsInfo = useState(null);
    const openConnectionDialog = useState(false);
    const eventState = useState([]);
    const eventUserInfo = useState(null);
    const addConnectionFor = useState(null);
    const authState = useAuthState();
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const ConnectionObj = useState({});
    const DeleteConnData = useState('');
    const openSettingDialog = useState(false);
    const ticketOrHotelState = useState('');
    const EditHotelOrTicketData = useState('');

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteConnection = useState({
        open: false,
        title: '',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const [modPermission, setModPermission] = React.useState(null);
    const loading = useState(false);
    const editSelectedParticipant = useState(null);

    useEffect(() => {
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        // if (eventState && eventState.get().length == 0) {
        //     ApiHelper.get(APIURLConstants.GET_SYSTEM_USERS)
        //         .then((res) => {
        //             eventState.set(res.data);
        //             // Helper.setStorage('users', res.data);
        //         })
        //         .catch((err) => {
        //             //... Check if user's session has expired
        //             if (err.response && err.response.status === 401) {
        //                 console.log(err);
        //             }
        //         });
        // }

        const pageInfo = pagingInfo.attach(Downgraded).get();
        if (pageInfo.itemsPerPage) {
            getParticipants();
            // getAllParticipants();
        }

        const userInfo = Helper.getStorage('userInfo');
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo))
        ) {
            setModPermission(FULL_PERMISSION);
        } else {
            setModPermission(VIEW_PERMISSION);
        }
    }, []);

    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getParticipants();
    };

    // const getAllParticipants = () => {
    //     const gEventInfo = Helper.getStorage('eventInfo');
    //     ApiHelper.get(
    //         APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
    //     ).then((res) => {
    //         if (res.data.rows) {
    //             allParticipants.set(res.data.rows);
    //         }
    //     });
    // };

    const getParticipants = () => {
        const eventInfo = Helper.getStorage('eventInfo');

        if (eventInfo) {
            loading.set(true);
            ApiHelper.get(
                APIURLConstants.GET_EVENT_ALLOTMENTS(
                    eventInfo.eventID,
                    0
                )
            )
                .then((res) => {
                    loading.set(false);

                    if (res.data) {
                        let usersData = [];
                        if (res.data.rows.length > 0) {
                            res.data.rows.map((item) => {
                                // console.log("item",JSON.parse(item.allotments[0].hotelSetting));
                                if (item.roleName !== 'Event Admin') {
                                    usersData.push({
                                        actualData: item,
                                        row: [
                                            {
                                                label: 'checkbox',
                                                key: 'eventUsersID',
                                                eventUsersID: item.eventUsersID,
                                                width: '0.1',
                                            },
                                            {
                                                label: 'Name',
                                                key: 'name',
                                                name: item.name,
                                                showLabel: false,
                                                width: '0.3',
                                                inColumn: true,
                                                toEmail: item.email,
                                                showEmail: true,
                                            },
                                            {
                                                label: 'Role',
                                                key: 'roleName',
                                                roleName: item.roleName,
                                                width: '0.2',
                                                showLabel: true,
                                                wrapUp: true,
                                            },
                                            {
                                                label: 'Tags',
                                                key: 'userTags',
                                                userTags: item.userTags,
                                                width: '0.2',
                                                showLabel: false,
                                                showChips: true,
                                                wrapUp: true,
                                            },
                                            {
                                                label: 'Hotel',
                                                key: 'hotelSettings',
                                                width: '0.15',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'FlightInfo',
                                                key: 'transportSetting',
                                                width: '0.2',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'Comp',
                                                key: 'ticketSettings',
                                                width: '0.15',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'Purchase',
                                                key: 'ticketSettings',
                                                width: '0.15',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'Add Purchase',
                                                key: 'ticketSettings',
                                                width: '0.2',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'AllotmentTicket',
                                                key: 'draftTicketSetting',
                                                width: '0.1',
                                                inColumn: true,
                                            },
                                            // {
                                            //     label: 'AllotmentDraftTransport',
                                            //     key: 'draftTransportSetting', 
                                            //     width: '0.1',
                                            //     inColumn: true,
                                            // }, 
                                            {
                                                label: 'AllotmentDraftFlight',
                                                key: 'draftFlightSetting',
                                                width: '0.1',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'AllotmentCredential',
                                                key: 'Credential',
                                                width: '0.1',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'AllotmentLunchRoom',
                                                key: 'LunchRoom',
                                                width: '0.1',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'Status',
                                                key: 'status',
                                                status: item.status
                                                    ? 'Active'
                                                    : 'Inactive',
                                                width: '0.1',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'Action',
                                                key: 'edit',
                                                edit: 'Edit',
                                                width: '0.1',
                                            },
                                        ],
                                        selected: false,
                                        CustomSelected: true,
                                    });
                                }
                            });
                        }

                        users.set(usersData);
                        if (pagingInfo.get().noOfPages == null) {
                            pagingInfo.set({
                                ...pagingInfo,
                                currentPage: pagingInfo.get().currentPage,
                                itemsPerPage: pagingInfo.get().itemsPerPage,
                                noOfPages: Math.ceil(
                                    res.data.totalCount /
                                    pagingInfo.get().itemsPerPage
                                ),
                            });
                        }
                    }
                })
                .catch((err) => {
                    loading.set(false);
                    //... Check if user's session has expired
                    if (err.response && err.response.status === 401) {
                        console.log(err);
                    }
                });
        }
    };

    const redirectToCreate = () => {
        openDialog.set(true);
    };

    const handleClose = () => {
        openDialog.set(false);
    };

    const editUser = (item) => {
        // eventUserInfo.set(userInfo.actualData);
        // openUserDialog.set(true);
        EditHotelOrTicketData.set(item)
        ticketOrHotelState.set(1);
        editSelectedParticipant.set([item])
        // console.log("item",item);
        openSettingDialog.set(true)
    };

    const editAll = () => {
        const selected = users.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            props.setSnackBarProps({
                ...props.props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select  participants first',
            });
        } else {
            editSelectedParticipant.set();
            editSelectedParticipant.set(selected);
            openUserEditAllDialog.set(true);
        }

        // eventUserInfo.set(userInfo.actualData);
        // openUserDialog.set(true);
    };

    const addConnection = (userInfo) => {
        eventUserInfo.set(userInfo.actualData);
        addConnectionFor.set('connections');
        openConnectionDialog.set(true);
    };

    const addConnectionLinkedWith = (userInfo) => {
        eventUserInfo.set(userInfo.actualData);
        addConnectionFor.set('linked with');
        openConnectionDialog.set(true);
    };

    const closeConnection = () => {
        openConnectionDialog.set(false);
    };

    const closeEditUser = () => {
        eventUserInfo.set(null);
        openUserDialog.set(false);
    };

    const closeEditAllUser = () => {
        editSelectedParticipant.set(null);
        openUserEditAllDialog.set(false);
    };

    // const selectAll = (event) => {
    //     setAll.set(event.target.checked);
    //     let newUsers = users.attach(Downgraded).get();
    //     newUsers.map((item) => (item['selected'] = event.target.checked));
    //     users.set(newUsers);
    // };
    const onCustomCheckSelect = (event, item) => {
        let newUsers = users.attach(Downgraded).get();
        // newUsers[index]['CustomSelected'] = event.target.checked;
        let index = newUsers.findIndex(x => x.actualData.eventUsersID === item.actualData.eventUsersID)
        newUsers[index]['CustomSelected'] = event.target.checked
        let rowProps = newUsers[index]['row']
        let rowPropIndex = rowProps.findIndex(x => x.key == 'skip_email')

        newUsers[index]['row'][rowPropIndex].excludeEmail = event.target.checked == true ? 1 : 0;
        users.set(newUsers);
        const gEventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');

        let requestObj = {
            eventID: gEventInfo.eventID,
            userID: userInfo.userID,
            eventUsersID: item.actualData.eventUsersID,
            excludeEmail: event.target.checked == true ? 1 : 0
        };

        ApiHelper.post(APIURLConstants.Update_Excluded_Email, requestObj)
            .then((res) => {
                if (res.data) {
                    getParticipants();
                    // getAllParticipants();
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Participant Updated Successfully',
                    });
                }
            })
    };

    const deleteParticipants = () => {
        const selected = users.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            let message =
                selected.length == users.get().length
                    ? 'Do you want to delete all participant allotments?'
                    : 'Do you want to delete selected participant allotments?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const onDeleteConnection = (value) => {
        let message = 'Do you want to remove connection ?';

        deleteConnection.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });

        const userInfoValue = Helper.getStorage('userInfo');
        if (value.connectionID != undefined) {
            ConnectionObj.set({
                connectionID: value.connectionID,
                modifiedBy: userInfoValue.userID,
            });
            DeleteConnData.set('connections');
        } else {
            ConnectionObj.set({
                eventID: value.eventID,
                userID: value.fromUserID,
                primaryUserID: value.userID,
                modifiedBy: userInfoValue.userID,
            });
            DeleteConnData.set('connectionWith');
        }
    };

    const handleConnection = () => {
        let requestObj = {
            connectionID: ConnectionObj.get().connectionID,
            modifiedBy: ConnectionObj.get().modifiedBy,
        };

        ApiHelper.post(APIURLConstants.DELETE_CONNECTIONS, requestObj)
            .then((res) => {
                if (res.data) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Connection deleted successfully',
                    });
                    setShowSearchRec(false);
                    getParticipants();
                    // getAllParticipants();
                    setTimeout(() => {
                        setAll.set(false);
                    }, 300);
                }
            })
            .catch((error) => {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting connection';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConnection.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const handleConnectionWith = () => {
        let requestObj = {
            eventID: ConnectionObj.get().eventID,
            userID: ConnectionObj.get().userID,
            primaryUserID: ConnectionObj.get().primaryUserID,
            modifiedBy: ConnectionObj.get().modifiedBy,
        };

        ApiHelper.post(APIURLConstants.DELETE_CONNECTION_WITH, requestObj)
            .then((res) => {
                if (res.data) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Connection deleted successfully',
                    });
                    setShowSearchRec(false);
                    getParticipants();
                    // getAllParticipants();
                    setTimeout(() => {
                        setAll.set(false);
                    }, 300);
                }
            })
            .catch((error) => {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting connection';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConnection.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const callExport = () => {
        const selected = users.get().filter((user) => user.selected === true);
        const allSelected = users
            .get()
            .filter((user) => user.selected === false);
        if (selected.length === 0) {
            generateExcelReport(allSelected);
        } else {
            generateExcelReport(selected);
        }
    };
    const editTicket = (item) => {
        EditHotelOrTicketData.set(item)
        ticketOrHotelState.set(3);
        console.log("item", item);
        openSettingDialog.set(true)

    }
    const editHotel = (item) => {
        EditHotelOrTicketData.set(item)
        ticketOrHotelState.set(2);
        console.log("item", item);
        openSettingDialog.set(true)

    }
    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.eventUsersID);
            });
            IDs = selectedIds.join(',');
        }
        const gEventInfo = Helper.getStorage('eventInfo');

        await ApiHelper.post(
            APIURLConstants.POST_ParticipantExport, { EventID: gEventInfo.eventID, UserIDs: IDs }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `Participant-Report`);
                }
            }
        });
    };
    const syncParticipants = () => {
        const selected = users
            .get()
            .filter(
                (user) => user.selected === true && user.actualData.status === 1
            );
        if (selected.length === 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select active participants first',
            });
        } else {
            syncParticipantsInfo.set(selected);
            openSyncParticipants.set(true);
        }
    };
    const closeSyncParticipants = () => {
        openSyncParticipants.set(false);
    };
    const deleteNotificationParticiapant = (userIDs, modifiedByID) => {
        const eventInfo = Helper.getStorage('eventInfo');
        const delObj = {
            usersIDs: userIDs.toString(),
            recordRefID: eventInfo.eventID,
            moduleID: 9,
            eventID: eventInfo.eventID,
            modifiedBy: modifiedByID
        }
        ApiHelper.post(APIURLConstants.DELETE_NON_MODULE_APP_NOTIFICATIONS, delObj)
            .then(result => {
                console.log("result", result);
            })
    }
    const handleConfirmation = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        let deletUsersID = [];
        users.get().map((user) => {
            if (user.selected === true) {
                deletUsersID.push(user.actualData.userID);
            }
        });
        const userInfoValue = Helper.getStorage('userInfo');
        ApiHelper.post(APIURLConstants.DELETE_HOTEL_SETTING, {
            Ids: deletUsersID.join(','),
            eventID: eventInfo.eventID,
            CreatedBy: userInfoValue.userID,
        })
            .then((res) => {
                if (res.data) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Participant allotments deleted successfully',
                    });
                    deleteNotificationParticiapant(deletUsersID.join(','), userInfoValue.userID)
                    // setShowSearchRec(false);
                    getParticipants();
                    // getAllParticipants();
                    // setTimeout(() => {
                    //     setAll.set(false);
                    // }, 300);
                }
            })
            .catch((error) => {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting participants';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const onSettingClick = () => {
        const selected = users.get().filter((user) => user.selected === true);
        const selecteduser = selected.length > 1 ? selected : selected[0];
        if (selected.length === 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select  participants first',
            });
        } else {
            EditHotelOrTicketData.set(selecteduser);
            if (selecteduser.length > 1 && selecteduser != undefined) {
                ticketOrHotelState.set(0);
            }
            else {
                ticketOrHotelState.set(1);
            }
            editSelectedParticipant.set(selected);
            openSettingDialog.set(true)

            // openUserEditAllDialog.set(true);
        }

    }
    const handleSettingClose = () => {
        openSettingDialog.set(false);
    };
    return (
        <Box
            sx={{
                maxHeight: 'calc(100vh - 70px)',
            }}
        >
            {loading.get() ? (
                <Box
                    sx={
                        loading.get()
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none', maxHeight: 'calc(100vh - 70px)' }}>
                    {users.get() ? (
                        <DataList
                            data={users.attach(Downgraded).get()}
                            onCustomCheckSelect={onCustomCheckSelect}
                            editRow={editUser}
                            handleClick={redirectToCreate}
                            title={''}
                            buttonTitle={'Add'}
                            // showEdit={true}
                            hideAdd={true}
                            hideDelete={true}
                            deleteRows={deleteParticipants}
                            showSearch={true}
                            showSelectAll={
                                users.get() && users.get().length > 0
                                    ? true
                                    : false
                            }
                            showAllotment={true}
                            syncParticipantsClick={syncParticipants}
                            // syncParticipants={false}
                            searchLabel={'Search'}
                            // showExport={false}
                            callExport={callExport}
                            editTicket={editTicket}
                            editHotel={editHotel}
                            showAllotmenticon={true}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            handlePageChange={handlePageChange}
                            addConnection={addConnection}
                            showSettings={true}
                            onSettingClick={onSettingClick}
                            addConnectionLinkedWith={addConnectionLinkedWith}
                            deleteConnection={onDeleteConnection}
                            modPermission={modPermission}
                            editAll={editAll}
                            isParticipantFilter={true}
                            windowDataList={true}
                            rowType={'allotment'}
                            showParticipantRoleTag={true}
                            showClearSearch={true} 
                            hideTagFilter={true}
                        />
                    ) : null}
                    {openDialog.get() && (
                        <UserListDialog
                            open={openDialog.get()}
                            title="Add Participant"
                            handleClose={handleClose}
                            users={eventState.attach(Downgraded).get()}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={props.setSnackBarProps}
                            getParticipants={getParticipants}
                            // getAllParticipants={getAllParticipants}
                            eventParticipants={
                                allParticipants.get().length > 0
                                    ? allParticipants.attach(Downgraded).get()
                                    : []
                            }
                        />
                    )}
                    {openConnectionDialog.get() && (
                        <ConnectionListDialog
                            open={openConnectionDialog.get()}
                            title="Add Connection"
                            handleClose={closeConnection}
                            users={eventState.attach(Downgraded).get()}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={props.setSnackBarProps}
                            getParticipants={getParticipants}
                            // getAllParticipants={getAllParticipants}
                            eventParticipants={
                                allParticipants.get().length > 0
                                    ? allParticipants.attach(Downgraded).get()
                                    : []
                            }
                            eventUserInfo={eventUserInfo
                                .attach(Downgraded)
                                .get()}
                            addConnectionFor={addConnectionFor
                                .attach(Downgraded)
                                .get()}
                        />
                    )}
                    {openUserDialog.get() && (
                        <EditParticipant
                            open={openUserDialog.get()}
                            eventUserInfo={eventUserInfo
                                .attach(Downgraded)
                                .get()}
                            title="Edit Participant"
                            handleClose={closeEditUser}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={props.setSnackBarProps}
                            getParticipants={getParticipants}
                        />
                    )}
                    {openUserEditAllDialog.get() && (
                        <EditAllParticipant
                            open={openUserEditAllDialog.get()}
                            eventUserInfo={editSelectedParticipant
                                .attach(Downgraded)
                                .get()}
                            title="Edit Participants"
                            handleClose={closeEditAllUser}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={props.setSnackBarProps}
                            getParticipants={getParticipants}
                        />
                    )}
                    {openSyncParticipants.get() && (
                        <SyncParticipant
                            open={openSyncParticipants.get()}
                            syncParticipantsInfo={syncParticipantsInfo
                                .attach(Downgraded)
                                .get()}
                            title="Sync Participant"
                            handleClose={closeSyncParticipants}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={props.setSnackBarProps}
                            getParticipants={getParticipants}
                        />
                    )}
                    {
                        <ConfirmationDialog
                            open={deleteConfirmation.get().open}
                            message={deleteConfirmation.get().message}
                            OkButtonText={deleteConfirmation.get().OkButtonText}
                            handleCnfClick={() =>
                                handleConfirmation(deleteConfirmation)
                            }
                            onCancelClick={() => {
                                deleteConfirmation.set({
                                    ...deleteConfirmation.get(),
                                    open: false,
                                });
                            }}></ConfirmationDialog>
                    }
                    {
                        <DeleteConnectionDialog
                            open={deleteConnection.get().open}
                            message={deleteConnection.get().message}
                            OkButtonText={deleteConnection.get().OkButtonText}
                            handleCnfClick={() =>
                                DeleteConnData.get() == 'connections'
                                    ? handleConnection(deleteConnection)
                                    : handleConnectionWith(deleteConnection)
                            }
                            onCancelClick={() => {
                                deleteConnection.set({
                                    ...deleteConnection.get(),
                                    open: false,
                                });
                            }}></DeleteConnectionDialog>
                    }
                    {openSettingDialog.get() && (
                        <TicketSettingsDialog
                            open={openSettingDialog.get()}
                            title="Add Settings"
                            handleClose={handleSettingClose}
                            selectedUserIds={editSelectedParticipant
                                .attach(Downgraded)
                                .get()}
                            isTicketOrHotel={ticketOrHotelState.attach(Downgraded).get()}
                            getParticipants={getParticipants}
                            editData={EditHotelOrTicketData.attach(Downgraded).get()}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={props.setSnackBarProps}
                            ModuleType={3}
                            setShowSearchRec={setShowSearchRec}
                        />
                    )}
                </Paper>
            )}
        </Box>
    );
};

export default Allotment;
